import { render, staticRenderFns } from "./WaterMonitorIndex.vue?vue&type=template&id=384f8105&scoped=true&"
import script from "./WaterMonitorIndex.vue?vue&type=script&lang=js&"
export * from "./WaterMonitorIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384f8105",
  null
  
)

export default component.exports